export default __webpack_public_path__ + "static/media/josh__O8A9915_final.c90b2427.jpg";